var _rect, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteChevronPurpleBackground = function SvgWhiteChevronPurpleBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "363 0 51 51"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 363,
    width: 51,
    height: 51,
    fill: "#72226D"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 377.647,
    y1: 30.6467,
    x2: 388.646,
    y2: 19.6465,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 388.354,
    y1: 19.6464,
    x2: 399.567,
    y2: 30.8598,
    stroke: "white"
  })));
};
export default SvgWhiteChevronPurpleBackground;